import React from 'react';
import { displayValue } from '../../components/titleAnalysis/displayUtils/displayValue';
import { gradeStyle, type Grade } from './reportModel';
import { Overline, ReportCard } from './reportParts';

/**
 * Grade card plus the summary and grade rationale.
 *
 * Requirement 11.6: the title grade (A-D) with its rationale and the summary.
 */
export const GradeCard: React.FC<{ grade: Grade }> = ({ grade }) => {
  const style = gradeStyle(grade);
  return (
    <section
      data-testid="title-analysis-grade"
      aria-label={`Title grade ${grade}`}
      className={`flex items-center gap-4 rounded-xl border p-[18px] ${style.card}`}
    >
      <div
        aria-hidden="true"
        className={`flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-xl text-[40px] font-bold leading-none ${style.tile}`}
      >
        {grade}
      </div>
      <div>
        <Overline>Title grade</Overline>
        <div className="text-base font-bold text-gray-900">Grade {grade}</div>
        <div className="text-[13px] text-gray-700">{style.description}</div>
      </div>
    </section>
  );
};

export const SummaryCard: React.FC<{ summary: string; rationale: string }> = ({
  summary,
  rationale,
}) => (
  <ReportCard testId="title-analysis-summary" title="Summary">
    <p className="whitespace-pre-wrap text-sm text-gray-700">{displayValue(summary)}</p>
    <div className="mt-3 border-t border-gray-100 pt-3">
      <Overline>Grade rationale</Overline>
      <p className="mt-1 whitespace-pre-wrap text-sm text-gray-700">{displayValue(rationale)}</p>
    </div>
  </ReportCard>
);
